/* eslint-disable max-len */
import React,{useState} from 'react'
import { GenerateDateFormat } from '../../redux/helper/DateConverter'


// const Buffer =  Array;

export default function ProfileSection({type, Details,handleFetch}) {
 

    const {PRIMARY_PHONE_NUMBER, DISTRIBUTOR_TYPE,CREATION_DATE,EMAIL_ADDRESS,PRODUCT_CATEGORIES, PARTY_NAME, ATTRIBUTE3, virtual_account_info} = Details
   
    return (
        <div className={`tab-pane fade  pt-[18px] ${type==='Profile' ? 'show active':''}`} 
            id="pills-profile" role="tabpanel" aria-labelledby="pills-profile-tab">
            <div className="flex -mx-[18px] lg:flex-row flex-col"> 
                <div className="lg:w-1/2 w-full px-[18px]"> 
                    <div className="border border-[#555259] sm:px-[38px] px-4 sm:pt-6 pt-4 sm:pb-[38px] pb-5 rounded-lg">
                        <p className="md:text-xs16 text-base font-bold text-[#555259]">Personal Details</p>
                        <div className="sm:pt-5 pt-4 flex -mx-1 flex-wrap">
                            <div className="px-1 sm:w-1/3 w-1/2">
                                <div className="w-full">
                                    <p className="text-sm font-semibold text-[#808285]">Mobile Number</p>
                                    <p className="pt-1.5 sm:text-lg text-base font-normal text-[#090406]">+91 {PRIMARY_PHONE_NUMBER}</p>
                                </div>
                            </div>
                            <div className="px-1 sm:w-1/3 w-1/2">
                                <div className="w-full">
                                    <p className="text-sm font-semibold text-[#808285]">Type</p>
                                    <p className="pt-1.5 sm:text-lg text-base font-normal text-[#090406]">{ATTRIBUTE3 ?ATTRIBUTE3:'-' }</p>
                                </div>
                            </div>
                            <div className="px-1 sm:w-1/3 w-1/2 sm:pt-0 pt-5">
                                <div className="w-full">
                                    <p className="text-sm font-semibold text-[#808285]">Registered On</p>
                                    <p className="pt-1.5 sm:text-lg text-base font-normal text-[#090406]">{GenerateDateFormat(CREATION_DATE)}</p>
                                </div>
                            </div>
                        </div>
                        <div className="sm:pt-5 pt-4 flex -mx-1 flex-wrap">
                            <div className="px-1 sm:w-1/3 w-1/2">
                                <div className="w-full">
                                    <p className="text-sm font-semibold text-[#808285]">Email Address</p>
                                    <p className="pt-1.5 sm:text-lg text-base font-normal text-[#090406] break-words">{EMAIL_ADDRESS}</p>
                                </div>
                            </div>
                            {/* Commenting this section as per externals request */}
                            {/* <div className="px-1 sm:w-1/3 w-1/2">
                                <div className="w-full">
                                    <p className="text-sm font-semibold text-[#808285]">Virtual Payment Account Number</p>
                                    <p className="pt-1.5 sm:text-lg text-base font-normal text-[#090406]">{virtual_account_info? virtual_account_info.receivers[0].account_number:'-' }</p>
                                </div>
                            </div>
                            <div className="px-1 sm:w-1/3 w-1/2 sm:pt-0 pt-5">
                                <div className="w-full">
                                    <p className="text-sm font-semibold text-[#808285]">Virtual Payment Account IFSC Number</p>
                                    <p className="pt-1.5 sm:text-lg text-base font-normal text-[#090406]">{virtual_account_info? virtual_account_info.receivers[0].ifsc:'-' }</p>
                                </div>
                            </div> */}
                        </div>
                        <div className="sm:pt-5 pt-4">
                            <p className="text-sm font-semibold text-[#808285]">Distributor Categories</p>
                            <div className="flex mt-2.5 flex-wrap">
                                {PRODUCT_CATEGORIES && PRODUCT_CATEGORIES.map((category,i)=>(
                                    <div key={category}className={`border border-dashed border-[#ED1C24] rounded-[11px] w-fit sm:px-3 mt-1 sm:ml-0 px-2 py-1.5 ${i !==0 ? 'md:ml-2':''}`}>
                                        <p className="sm:text-lg text-base font-normal text-[#090406]">{category}</p>
                                    </div>
                                ))}
                                
                            </div>
                        </div>
                    </div>
                </div> 
                <div className="lg:w-1/2 w-full px-[18px] lg:mt-0 mt-3.5"> 
                    <div className="border border-[#555259] sm:px-[38px] px-4 sm:pt-6 pt-4 sm:pb-[56px] pb-5 rounded-lg lg:h-full h-auto">
                        <p className="md:text-xs16 text-base font-bold text-[#555259]">Company Details</p>
                        <div className="sm:pt-5 pt-4">
                            <p className="text-sm font-semibold text-[#808285]">Company Name</p>
                            <p className="lg:pt-1.5 pt-0 sm:text-lg text-base font-normal text-[#090406]">{PARTY_NAME}.</p>
                        </div>
                        <div className="flex -mx-1 sm:pt-5 pt-4">
                            <div className="px-1 w-1/2">
                                <p className="text-sm font-semibold text-[#808285]">Mobile Number</p>
                                <p className="lg:pt-1.5 pt-0 sm:text-lg text-base font-normal text-[#090406]">+91 {PRIMARY_PHONE_NUMBER}</p>
                            </div>
                            <div className="px-1 w-1/2">
                                <p className="text-sm font-semibold text-[#808285]">Email Address</p>
                                <p className="lg:pt-1.5 pt-0 sm:text-lg text-base font-normal text-[#090406] break-words">{EMAIL_ADDRESS}</p>
                            </div>
                        </div>
                        <div className="flex -mx-1 sm:pt-5 pt-4">
                            <div className="px-1 w-1/2">
                                <p className="text-sm font-semibold text-[#808285]">GSTIN</p>
                                <p className="lg:pt-1.5 pt-0 sm:text-lg text-base font-normal text-[#090406]">GSTIN {Details?.GSTIN || Details.SHIP_AND_BILL_ADDRESSES.length > 0 && Details.SHIP_AND_BILL_ADDRESSES[0]?.ATTRIBUTE2}</p>
                            </div>
                            <div className="px-1 w-1/2">
                                <p className="text-sm font-semibold text-[#808285]">PAN Number</p>
                                <p className="lg:pt-1.5 pt-0 sm:text-lg text-base font-normal text-[#090406] break-words">{Details?.PAN_NUMBER ||Details.SHIP_AND_BILL_ADDRESSES.length > 0 && Details.SHIP_AND_BILL_ADDRESSES[0]?.ATTRIBUTE2.substring(2,12)}</p>
                            </div>
                        </div>
                    </div>
                </div> 
            </div>
        </div>
    )
}